NavItemComponent
<template>
  <div>
    <side-bar class="p-2" :sidebar-item-color="sidebarBackground">
      <mobile-menu slot="content"></mobile-menu>
      <!-- <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link> -->

      <div v-if="menu">
        <NavItemComponent
          v-for="(menu_item, index) in menu"
          :key="index"
          :title="menu_item.title"
          :route_name="menu_item.route_name"
          :icon="menu_item.icon"
          :child="menu_item.child"
          :is_visible="isMenuVisible(menu_item)"
          :has_children="
            menu_item.child !== undefined && menu_item.child.length > 0
          "
        >
        </NavItemComponent>
      </div>

      <div style="height: 100px"></div>
    </side-bar>
  </div>
</template>

<script>
import MobileMenu from "./MobileMenu.vue";
import NavItemComponent from "./NavItem.vue";
import { permissions } from "@/constants";

export default {
  components: {
    MobileMenu,
    NavItemComponent
  },
  data() {
    return {
      sidebarBackground: "red",
      // sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),

      menu: [
        {
          title: "Dashboard",
          icon: "dashboard",
          route_name: "/dashboard",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_DASHBOARD
          )
        },
        {
          route_name: "#professional-management",
          title: "Professionals",
          icon: "compass_calibration",

          child: [
            {
              route_name: "Professional Management",
              title: "Professional Management",
              alias: "PM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PROFESSIONALS
              )
            },
            {
              route_name: "Professional Services",
              title: "Professional Services",
              alias: "PS",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PROFESSIONAL_SERVICE
              )
            }
          ]
        },
        {
          route_name: "#handyman-management",
          title: "Handymen",
          icon: "compass_calibration",

          child: [
            {
              route_name: "Handyman Management",
              title: "Handyman Management",
              alias: "HM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_HANDYMAN
              )
            },
            {
              route_name: "Handyman Services",
              title: "Handyman Services",
              alias: "HS",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_HANDYMAN_SERVICE
              )
            }
          ]
        },

        {
          route_name: "#vendor-management",
          title: "Vendor",
          icon: "compass_calibration",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_VENDOR
          ),
          child: [
            {
              route_name: "Vendor Management",
              title: "Vendor Management",
              alias: "VM"
            }
          ]
        },
        {
          title: "Portfolios",
          route_name: "/portfolios",
          icon: "work_outline",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_PORTFOLIO
          )
        },
        {
          route_name: "#estate-management",
          title: "Real Estates",
          icon: "business",
          child: [
            {
              route_name: "Estate Management",
              title: "Estate Management",
              alias: "EM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ESTATE
              )
            },
            {
              route_name: "Estate Realtors",
              title: "Realtors Management",
              alias: "RM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_REALTOR
              )
            },
            {
              route_name: "Estate Features",
              title: "Feature Categories",
              alias: "FC",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ESTATE_FEATURE_CATEGORY
              )
            },
            {
              route_name: "Estate Types",
              title: "Property Types",
              alias: "PT",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ESTATE_PROPERTY_TYPE
              )
            }
          ]
        },
        {
          route_name: "#catalog-management",
          title: "Products",
          icon: "store",
          child: [
            {
              route_name: "products",
              title: "All Products",
              alias: "PD",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PRODUCT
              )
            },
            {
              route_name: "Product Tags",
              title: "Tags",
              alias: "TG",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PRODUCT_TAG
              )
            },
            {
              route_name: "Product Categories",
              title: "Categories",
              alias: "CA",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PRODUCT_CATEGORY
              )
            },
            {
              route_name: "Product Attribute",
              title: "Attributes",
              alias: "AT",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PRODUCT_ATTRIBUTE
              )
            }
          ]
        },
        {
          route_name: "#order-management",
          title: "Orders",
          icon: "shopping_basket",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_PRODUCT
          ),
          child: [
            {
              route_name: "product-orders",
              title: "All Orders",
              alias: "OR",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ORDER
              )
            },
            {
              route_name: "transactions",
              title: "Transactions",
              alias: "TL",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_TRANSACTION
              )
            },
            {
              route_name: "Buyers",
              title: "Buyers",
              alias: "BY",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_BUYER
              )
            },
            {
              route_name: "Order Payout",
              title: "Order Payouts",
              alias: "OP",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ORDER_PAYOUT
              )
            }
          ]
        },
        {
          route_name: "#user-management",
          title: "Users",
          icon: "group",

          child: [
            {
              route_name: "User Management",
              title: "User Management",
              alias: "UM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_USER
              )
            },
            {
              route_name: "Role Management",
              title: "Role Management",
              alias: "RM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ROLE
              )
            },
            {
              route_name: "User Login Location",
              title: "Users Location",
              alias: "UL",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_USER_LOGIN_LOCATION
              )
            },
            {
              route_name: "Offers",
              title: "User Offers ",
              alias: "OF",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_OFFERS
              )
            }
          ]
        },
        {
          route_name: "#buyer-management",
          title: "Buyers",
          icon: "group",

          child: [
            {
              route_name: "Buyers Management",
              title: "Buyers Management",
              alias: "BM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_BUYERS
              )
            }
          ]
        },
        {
          route_name: "#affiliate-management",
          title: "Affiliate",
          icon: "group",

          child: [
            {
              route_name: "Affiliate Management",
              title: "Affiliate Management",
              alias: "AM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_AFFILIATE
              )
            },
            {
              route_name: "Affiliate Sales",
              title: "Sales Management",
              alias: "SM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_AFFILIATE_SALES
              )
            },
            {
              route_name: "Affiliate Payouts",
              title: "Affiliate Payouts",
              alias: "AP",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_AFFILIATE_PAYOUTS
              )
            }
          ]
        },
        {
          route_name: "#point-management",
          title: "Points",
          icon: "money",

          child: [
            {
              route_name: "Points",
              title: "Point  Management",
              alias: "PM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_POINTS
              )
            },
            {
              route_name: "Point Orders",
              title: "Point Order Management",
              alias: "POM",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_POINT_ORDERS
              )
            }
          ]
        },
        {
          route_name: "Faq",
          title: "FAQ",
          icon: "book",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_FAQ
          )
        },
        {
          route_name: "promotions",
          title: "Promotions",
          icon: "compass_calibration",
          is_visible: this.$store.getters["auth/has_module_permission"](
            permissions.VIEW_PROMOTIONS
          )
        },
        {
          route_name: "#site-management",
          title: "Site Management",
          icon: "settings",
          child: [
            {
              route_name: "Adverts",
              title: "Adverts",
              alias: "ADS",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_ADVERTISEMENT
              )
            },
            {
              route_name: "Commission",
              title: "Commission",
              alias: "%%",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_COMMISSION
              )
            },
            {
              route_name: "Testimonial",
              title: "Testimonial",
              alias: "TS",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_TESTIMONIAL
              )
            },

            {
              route_name: "Pages Content",
              title: "Pages Content",
              alias: "PC",
              is_visible: this.$store.getters["auth/has_module_permission"](
                permissions.VIEW_PAGE_CONTENT
              )
            }
          ]
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  methods: {
    isMenuVisible(item) {
      if (item.is_visible === false) return false;
      if (item.child && item.child.length > 0) {
        return item.child.some((c) =>
          c.is_visible === undefined ? true : c.is_visible
        );
      }
      return item.is_visible !== false;
    }
  }
};
</script>
